// extracted by mini-css-extract-plugin
export default {"EmptyState":"OriginsList_EmptyState__FPigo"};